module.exports = __webpack_public_path__ + "img/t2linux.3f0908bd.webp";